// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* ##### Code for CountryHeader2  --> Sidebar, Openbar,Closebar #####*/

.header-open-detail {
  position: relative;
  display: none;
  z-index: 1;
}

.header-open-detail > p {
  border: 2px solid rgb(82, 78, 78);
  border-radius: 4px;
  position: relative;
  z-index: 5;
}

.header-open-detail > p > i {
  cursor: pointer;
  font-size: 5vmin;
  font-weight: 700;
  color: rgb(230, 219, 219);
}

.sidebar-2 {
  background-color: #122b4f;
  border-top: 2px solid #2a4367;
  width: 100% !important;
  position: absolute;
  right: 0;
  left: 0;
  top: 60px;
  display: flex;
  align-items: center;
  height: 0;
  transition: 0.5s ease;
  flex-direction: row;
  z-index: 99;
}

.sidebar-2 > span {
  height: 100%;
  width: 100%;
  border-right: 2px solid #2a4367;
  color: rgb(193, 193, 193);
  cursor: pointer;
}
.sidebar-2 span svg {
}
.sidebar-2 span svg path {
  color: white;
}

.sidebar-2 > div {
  /* margin: 1.5vmin 0;
  position: relative;
  width: auto;
  transition: .5s ease-in-out; */
}

/* ##### CountryHeader2  --> Dropdown #####*/

.SubHeader {
  background-color: rgb(228, 228, 224) !important;
  cursor: pointer;
  border-bottom: 3px solid white;
}

.SubHeader > span {
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
}
.SubHeader > span > i {
  transition: 0.2s ease-in-out;
}
.SubHeader > span > i.active {
  transform: rotate(180deg);
  /* transform: scaley(-1); */
}

.SubHeader:hover {
  background-color: rgb(233, 182, 116) !important;
}

.last_item {
  border-bottom: none;
}
.css-6hp17o-MuiList-root-MuiMenu-list {
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}
.css-6hp17o-MuiList-root-MuiMenu-list > :hover {
}

.css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper {
  scrollbar-width: 2px !important;
}
.css-mhc70k-MuiGrid-root > .MuiGrid-item {
  padding-top: 0 !important;
}

/* ##### CountryHeader2  --> End #####*/

@media screen and (max-width: 950px) {
  .detail-link {
    display: none !important;
    background-color: white;
  }

  .header-open-detail {
    display: block;
  }
}

@media screen and (max-width: 750px) {
  .header > :last-child {
    display: none;
  }

  .bar {
    display: block;
  }

  .header > :nth-child(2) {
    font-size: 3vmin;
  }
}

@media screen and (max-width: 500px) {
}
`, "",{"version":3,"sources":["webpack://./src/modules/Headers/CountryHeader2.css"],"names":[],"mappings":";AACA,sEAAsE;;AAEtE;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,yBAAyB;EACzB,eAAe;AACjB;AACA;AACA;AACA;EACE,YAAY;AACd;;AAEA;EACE;;;gCAG8B;AAChC;;AAEA,4CAA4C;;AAE5C;EACE,+CAA+C;EAC/C,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;AACA;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;;AAEA,uCAAuC;;AAEvC;EACE;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;AACA","sourcesContent":["\n/* ##### Code for CountryHeader2  --> Sidebar, Openbar,Closebar #####*/\n\n.header-open-detail {\n  position: relative;\n  display: none;\n  z-index: 1;\n}\n\n.header-open-detail > p {\n  border: 2px solid rgb(82, 78, 78);\n  border-radius: 4px;\n  position: relative;\n  z-index: 5;\n}\n\n.header-open-detail > p > i {\n  cursor: pointer;\n  font-size: 5vmin;\n  font-weight: 700;\n  color: rgb(230, 219, 219);\n}\n\n.sidebar-2 {\n  background-color: #122b4f;\n  border-top: 2px solid #2a4367;\n  width: 100% !important;\n  position: absolute;\n  right: 0;\n  left: 0;\n  top: 60px;\n  display: flex;\n  align-items: center;\n  height: 0;\n  transition: 0.5s ease;\n  flex-direction: row;\n  z-index: 99;\n}\n\n.sidebar-2 > span {\n  height: 100%;\n  width: 100%;\n  border-right: 2px solid #2a4367;\n  color: rgb(193, 193, 193);\n  cursor: pointer;\n}\n.sidebar-2 span svg {\n}\n.sidebar-2 span svg path {\n  color: white;\n}\n\n.sidebar-2 > div {\n  /* margin: 1.5vmin 0;\n  position: relative;\n  width: auto;\n  transition: .5s ease-in-out; */\n}\n\n/* ##### CountryHeader2  --> Dropdown #####*/\n\n.SubHeader {\n  background-color: rgb(228, 228, 224) !important;\n  cursor: pointer;\n  border-bottom: 3px solid white;\n}\n\n.SubHeader > span {\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 2rem;\n}\n.SubHeader > span > i {\n  transition: 0.2s ease-in-out;\n}\n.SubHeader > span > i.active {\n  transform: rotate(180deg);\n  /* transform: scaley(-1); */\n}\n\n.SubHeader:hover {\n  background-color: rgb(233, 182, 116) !important;\n}\n\n.last_item {\n  border-bottom: none;\n}\n.css-6hp17o-MuiList-root-MuiMenu-list {\n  padding-bottom: 0 !important;\n  padding-top: 0 !important;\n}\n.css-6hp17o-MuiList-root-MuiMenu-list > :hover {\n}\n\n.css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper {\n  scrollbar-width: 2px !important;\n}\n.css-mhc70k-MuiGrid-root > .MuiGrid-item {\n  padding-top: 0 !important;\n}\n\n/* ##### CountryHeader2  --> End #####*/\n\n@media screen and (max-width: 950px) {\n  .detail-link {\n    display: none !important;\n    background-color: white;\n  }\n\n  .header-open-detail {\n    display: block;\n  }\n}\n\n@media screen and (max-width: 750px) {\n  .header > :last-child {\n    display: none;\n  }\n\n  .bar {\n    display: block;\n  }\n\n  .header > :nth-child(2) {\n    font-size: 3vmin;\n  }\n}\n\n@media screen and (max-width: 500px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
